import { combineReducers } from 'redux';
import {
  ADD_WARNING,
  CLOSE_WARNING,
  ADD_ERROR,
  CLOSE_ERROR,
  SHOW_FINISHED_ARTWORK_INFO,
  CLOSE_FINISHED_ARTWORK_INFO,
} from '@app/actions/_types';

const initialErrorPopupState = {
  locKey: '',
  message: '',
  active: false,
  intlValues: {},
  onClose: null,
  onConfirm: null,
  closeLocKey: 'qau-ok-btn',
  confirmLocKey: 'qau-confirm-btn',
  titleLocKey: 'qau-popup-title-error',
};

const initialWarningPopupState = {
  locKey: '',
  message: '',
  active: false,
  intlValues: {},
  onClose: null,
  onConfirm: null,
  closeLocKey: 'qau-ok-btn',
  confirmLocKey: 'qau-confirm-btn',
  titleLocKey: 'qau-popup-title-warning',
};

const initialArtworkInfoPopupState = {
  active: false,
};

export const errorPopupReducer = (state = initialErrorPopupState, { type, payload } = {}) => {
  switch (type) {
    case CLOSE_ERROR:
      return { ...initialErrorPopupState, active: false };
    case ADD_ERROR:
      return { ...state, ...payload, active: true };
    default:
      return state;
  }
};

export const warningPopupReducer = (state = initialWarningPopupState, { type, payload } = {}) => {
  switch (type) {
    case CLOSE_WARNING:
      return { ...initialErrorPopupState, active: false };
    case ADD_WARNING:
      return { ...state, ...payload, active: true };
    default:
      return state;
  }
};

export const artworkInfoPopupReducer = (state = initialArtworkInfoPopupState, { type, payload } = {}) => {
  switch (type) {
    case CLOSE_FINISHED_ARTWORK_INFO:
      return { ...initialArtworkInfoPopupState, active: false };
    case SHOW_FINISHED_ARTWORK_INFO:
      return { ...state, ...payload, active: true };
    default:
      return state;
  }
};

export default combineReducers({
  artworkInfo: artworkInfoPopupReducer,
  warning: warningPopupReducer,
  error: errorPopupReducer,
});
